import { render, staticRenderFns } from "./Mastercard.vue?vue&type=template&id=550fc508&scoped=true"
import script from "./Mastercard.vue?vue&type=script&lang=js"
export * from "./Mastercard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550fc508",
  null
  
)

export default component.exports